import { render, staticRenderFns } from "./taskSort.vue?vue&type=template&id=16227617&"
import script from "./taskSort.vue?vue&type=script&lang=js&"
export * from "./taskSort.vue?vue&type=script&lang=js&"
import style0 from "./taskSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports